window.reparacoesData = window.reparacoesData || {};

// OPPO A-Series
window.reparacoesData["a76"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câmera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a77-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "109,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câmera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a96"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "119,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câmera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a16"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câmera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a16s"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "59,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câmera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a35"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a54-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câmera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a54"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a54s"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "59,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a55-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a74-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a74"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a94-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a94"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a95-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a15"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a53-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "64,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a53s"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a72"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a73-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a73"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a91"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["a71"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "49,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

// OPPO Find X Series
window.reparacoesData["find-x5-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "44,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "44,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["find-x5-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "409,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["find-x5"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "59,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["find-x3-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["find-x3-neo"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["find-x3-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "279,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

// OPPO Reno Series
window.reparacoesData["reno-7-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-7"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "44,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-8-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "79,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-8-lite-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-8-pro-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "79,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-6-pro-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "59,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-6"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-4-pro-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["reno-4-z-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "89,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData = window.reparacoesData || {};

window.reparacoesData["oppo-a76"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a77-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "109,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câmera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a96"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "119,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a16"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a16s"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "59,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a35"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a54-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a54"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a54s"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "59,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a55-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a74-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a74"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a94-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a94"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a95-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a15"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a53-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "64,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a53s"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a72"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a73-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a73"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a91"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "139,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a71"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "49,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-find-x5-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "44,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "44,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-find-x5-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "409,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-find-x5"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "59,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-find-x3-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-find-x3-neo"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-find-x3-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "279,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-7-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-7"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "44,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-8-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "79,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-8-lite-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-8-pro-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "79,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-6-pro-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "159,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "59,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-6"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "179,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-4-pro-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-reno-4-z-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "89,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a78-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "109,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "Sob consulta" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a17"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "44,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a57"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "59,90€" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["oppo-a57s"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Bateria", preco: "Sob consulta" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Câamera frontal", preco: "Sob consulta" },
    { nome: "Câamera Traseira", preco: "Sob consulta" },
    { nome: "Tampa Traseira", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
